import { useContext } from "react"
import { LanguageContext } from "../App"
import { base_url } from "../util/GlobalConfigs"


const DemoPage = () =>{

  const language = useContext(LanguageContext)

    return (
        <>
        <div className="px-5">
          <video height={500} width={700} id="video" controls>
            <source src={base_url+"/demo.mp4"} type="video/mp4" />
          </video>
        </div>
        {/*
          <div className="px-5">
            <h1 className="mt-5"> {language.main.p1.h}</h1>
            <p>{language.main.p1.p}</p>
          </div>
          <hr />
          <div className="row mt-5">
              <div className="col-sm-6 col-12 px-5">
                <h1>  {language.main.p2.h} </h1>
                <p>   {language.main.p2.p} </p>
              </div>
              <div className="col-sm-6 col-12 px-5">
                <h1>  {language.main.p3.h} </h1>
                <p>{language.main.p3.p}</p>
              </div>
          </div>
        */}
        </>
    )
}

export default DemoPage
